export interface CompanySettingsState {
  enabledModules: string[]
  enabledCategories: string[]
  loaded: boolean
}

export const initialCompanySettingsState: CompanySettingsState = {
  enabledModules: [],
  enabledCategories: [],
  loaded: false
}
